import React, { useEffect, createElement } from 'react';
import { Helmet } from 'react-helmet';
export function SEOHead() {
  useEffect(() => {
    // Set document title
    document.title = 'Adiós al Caos por el Estrés Laboral | Método CIERRE 90 - Sistema de Productividad';
    // Create or update meta tags
    const metaTags = [{
      name: 'description',
      content: 'Reduce la saturación mental y mejora tu enfoque con el Método CIERRE 90. Sistema visual de productividad para profesionales, freelancers y emprendedores. 7 ebooks por solo $9.95 USD.'
    }, {
      name: 'keywords',
      content: 'productividad, estrés laboral, método CIERRE 90, gestión del tiempo, enfoque, concentración, burnout, trabajo remoto, freelance, emprendedores, sistema visual, timer pomodoro, productividad sin estrés'
    }, {
      name: 'author',
      content: 'Método CIERRE 90'
    }, {
      name: 'robots',
      content: 'index, follow'
    }, {
      name: 'googlebot',
      content: 'index, follow'
    }, {
      name: 'bingbot',
      content: 'index, follow'
    }, {
      name: 'yandex',
      content: 'index, follow'
    }, {
      name: 'baidu',
      content: 'index, follow'
    }, {
      name: 'language',
      content: 'Spanish'
    }, {
      name: 'revisit-after',
      content: '7 days'
    },
    // Open Graph
    {
      property: 'og:type',
      content: 'product'
    }, {
      property: 'og:url',
      content: window.location.href
    }, {
      property: 'og:title',
      content: 'Adiós al Caos por el Estrés Laboral | Método CIERRE 90'
    }, {
      property: 'og:description',
      content: 'Sistema visual de productividad para reducir el estrés y mejorar el enfoque. 7 ebooks por $9.95 USD. Oferta por tiempo limitado.'
    }, {
      property: 'og:image',
      content: 'https://cdn.magicpatterns.com/uploads/nVi5D7PkQzVXACwNVXfAGp/EBOOK_PRINCIPAL.png'
    }, {
      property: 'og:locale',
      content: 'es_ES'
    }, {
      property: 'og:site_name',
      content: 'Método CIERRE 90'
    },
    // Twitter
    {
      name: 'twitter:card',
      content: 'summary_large_image'
    }, {
      name: 'twitter:url',
      content: window.location.href
    }, {
      name: 'twitter:title',
      content: 'Adiós al Caos por el Estrés Laboral | Método CIERRE 90'
    }, {
      name: 'twitter:description',
      content: 'Sistema visual de productividad para reducir el estrés y mejorar el enfoque. 7 ebooks por $9.95 USD.'
    }, {
      name: 'twitter:image',
      content: 'https://cdn.magicpatterns.com/uploads/nVi5D7PkQzVXACwNVXfAGp/EBOOK_PRINCIPAL.png'
    }];
    metaTags.forEach(({
      name,
      property,
      content
    }) => {
      const attribute = name ? 'name' : 'property';
      const value = name || property;
      let meta = document.querySelector(`meta[${attribute}="${value}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, value!);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });
    // Add canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', window.location.href);
    // Add structured data
    const structuredData = {
      '@context': 'https://schema.org',
      '@graph': [{
        '@type': 'Product',
        name: 'Adiós al Caos por el Estrés Laboral - Método CIERRE 90',
        description: 'Sistema visual de productividad para reducir el estrés laboral y mejorar el enfoque. Incluye 7 ebooks con el Método CIERRE 90 para cerrar tareas sin agotamiento.',
        image: 'https://cdn.magicpatterns.com/uploads/nVi5D7PkQzVXACwNVXfAGp/EBOOK_PRINCIPAL.png',
        brand: {
          '@type': 'Brand',
          name: 'Método CIERRE 90'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://mikioscodigital.com/cart/51834224541977:1',
          priceCurrency: 'USD',
          price: '9.95',
          priceValidUntil: '2025-12-31',
          availability: 'https://schema.org/InStock',
          itemCondition: 'https://schema.org/NewCondition'
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.9',
          reviewCount: '5000'
        }
      }, {
        '@type': 'WebPage',
        name: 'Adiós al Caos por el Estrés Laboral | Método CIERRE 90',
        description: 'Reduce la saturación mental y mejora tu enfoque con el Método CIERRE 90. Sistema visual de productividad para profesionales, freelancers y emprendedores.',
        url: window.location.href,
        inLanguage: 'es-ES'
      }, {
        '@type': 'FAQPage',
        mainEntity: [{
          '@type': 'Question',
          name: '¿Qué es el Método CIERRE 90?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Un sistema visual de productividad que te ayuda a cerrar tareas importantes en bloques de 90 minutos, reduciendo el estrés y mejorando el enfoque sin agotamiento.'
          }
        }, {
          '@type': 'Question',
          name: '¿Qué incluye el pack completo?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'El pack incluye 7 ebooks: el libro principal "Adiós al Caos por el Estrés Laboral" más 6 bonos sobre enfoque, productividad, reuniones efectivas y gestión de mensajes.'
          }
        }]
      }, {
        '@type': 'Organization',
        name: 'Método CIERRE 90',
        url: window.location.origin,
        logo: 'https://cdn.magicpatterns.com/uploads/nVi5D7PkQzVXACwNVXfAGp/EBOOK_PRINCIPAL.png'
      }]
    };
    let script = document.querySelector('script[type="application/ld+json"]') as HTMLScriptElement;
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(structuredData);
    // Set language attribute on html element
    document.documentElement.lang = 'es';
  }, []);
  return null;
}